// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__aGjsM","line1":"Loader_line1__rX+Z9","line2":"Loader_line2__DF65R","line3":"Loader_line3__2Eqy4"};